/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles } from '@material-ui/core';
import { Settings, Subject } from '@material-ui/icons';
import TextEditor from 'components/TextEditor';
import ToggleCard from 'components/ToggleCard';
import i18n from 'i18n';
import React from 'react';
import clsx from 'clsx';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import GenericForm from 'skyone-lib/lib/GenericForm';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface MaintenanceImmediate {
  enabled: boolean;
  message: string;
  terminate_sessions: boolean;
}

export const immediateInitialValues = {
  enabled: false,
  message: '',
  terminate_sessions: false,
};

export interface Props {
  defaultValue: MaintenanceImmediate;
  companySelected: CompanyData | null;
  role?: RolesEnum;
  disabled?: boolean;
  onChange: (values: MaintenanceImmediate) => void;
}

const Form = ({
  defaultValue,
  role,
  companySelected,
  disabled,
  onChange,
}: Props) => {
  const classes = useStyles();
  const handleChange = (values: MaintenanceImmediate, toggle = true) => {
    const newValues = { ...values, enabled: toggle };

    onChange(newValues);
  };

  return (
    <ToggleCard
      active={defaultValue?.enabled}
      id="toggle-manual-maintenance"
      title={i18n.t('MAINTENANCE_MANUAL_KEY')}
      icon={
        <Settings
          className={clsx({
            [classes.iconGreen]: inAdminView(role, companySelected),
            [classes.iconGray]: inSuperAdminView(role, companySelected),
            [classes.iconBlue]: inOperatorView(role, companySelected),
            [classes.iconYellow]: companySelected,
          })}
        />
      }
      getActive={(value: boolean) => handleChange(defaultValue, !value)}
      disable={disabled}
    >
      <Grid container className={classes.FormContainer}>
        <GenericForm
          overrideClasses={{ checkboxLabel: { fontSize: 12, fontWeight: 500 } }}
          errors={[]}
          values={defaultValue}
          setFieldValue={(key, value) =>
            handleChange({ ...defaultValue, [key]: value })
          }
          screenFields={[
            {
              gridXs: 6,
              label: i18n.t('TERMINATE_SESSIONS_KEY'),
              stateKey: 'terminate_sessions',
              isCheckbox: true,
            },
          ]}
        />

        <Grid item className={classes.textFieldContainer}>
          <Subject className={classes.subject} />

          <TextEditor
            initialValue={defaultValue?.message || ''}
            title={i18n.t('ADD_MESSAGE_MAINTENANCE_KEY')}
            getValue={(value: string) =>
              handleChange(
                { ...defaultValue, message: value },
                defaultValue.enabled
              )
            }
            readOnly={disabled}
            maxLength={800}
          />
        </Grid>
      </Grid>
    </ToggleCard>
  );
};

export default Form;
